module.exports = require('./helpers/bundle-url').getBundleURL('1G2bZ') + "logo.90547532.png" + "?" + Date.now();